module.exports = __webpack_public_path__ + "img/noble1.f09e14b5.png";